import styled from 'styled-components';
import {
  grey2,
  grey3,
  grey5,
  grey6,
  grey9,
  grey10,
  purple1,
  purple7,
  purple8,
  purple9,
} from 'approot/shared/styles/colours.style';
import { hexColourToRGBArray } from 'lib/strings/strings.colour';
import {
  baseBoxShadowFocus,
  standardInsetBoxShadow,
} from 'approot/shared/styles/borders.style';
import { PillButtonBaseStyled } from './pill.style';

type PillButtonProps = {
  isSelected?: boolean;
  $noBorder?: boolean;
};

export const PillButtonStyled = styled.button<PillButtonProps>`
  ${PillButtonBaseStyled}
  &:hover {
    color: ${grey10};
    border: 1px solid ${grey9};
    background-color: ${grey2};
    cursor: pointer;
  }

  &:focus {
    outline: none;
    color: ${grey9};
    border: 1px solid ${grey5};
    box-shadow: ${baseBoxShadowFocus};
    background-color: ${grey2};
  }

  &:active {
    color: ${grey10};
    border: 1px solid ${grey9};
    background-color: ${grey2};

    ${standardInsetBoxShadow}
  }

  &:disabled {
    color: ${grey6};
    border: 1px solid ${grey5};
    background-color: ${grey3};
    cursor: not-allowed;
  }

  ${props => props.$noBorder && 'border: none;'}

  ${props =>
    props.isSelected &&
    `
    color: ${purple8};
    border: 1px solid ${purple7};
    background-color: ${purple1};
    
    &:hover {
      color: ${purple9};
      border: 1px solid ${purple9};
      background-color: ${purple1};
    }

    &:focus {
      color: ${purple8};
      border: 1px solid ${purple7};
      box-shadow: ${baseBoxShadowFocus};
      background-color: ${purple1};
    }

    &:active {
      color: ${purple9};
      border: 1px solid ${purple7};
      background-color: ${purple1};
      box-shadow: inset rgba(${hexColourToRGBArray(purple8).join(',')}, 0.24);
    }

    &:disabled {
      color: ${grey6};
      border: 1px solid ${grey5};
      background-color: ${grey3};
      cursor: not-allowed;
    }
  `};
`;
